// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zTcsJK{display:block}.be5RQ1{width:26px;display:flex;justify-content:center;background:lightblue;color:black;border:none;background:no-repeat;padding:0;margin:0;transition:transform .2s;cursor:pointer}.be5RQ1:hover{opacity:.7;transform:scale(1.18)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zTcsJK`,
	"button": `be5RQ1`
};
export default ___CSS_LOADER_EXPORT___;
